<template>
	<div>
		<v-card-text class="pa-0" style="height: 500px; overflow-y: auto;">
			<v-layout class="pa-2" row wrap style="height: auto;" v-if="channel">
				<v-flex xs6 style="padding-bottom: 5px;" pr-1>
					<v-select
					:items="channelTypes"
					v-model="channel.type"
					label="Type"
					item-text="label"
					item-value="value">
				</v-select>

				<v-layout row>
					<v-flex xs6>
						<h6 v-if="!$is_admin()">{{channel.name}}</h6>
						<v-text-field v-if="$is_admin()" readonly v-model="channel.name" label="Stream name"></v-text-field>
					</v-flex>
					<v-flex xs6>
						<v-text-field v-model="channel.title" label="Title"></v-text-field>
					</v-flex>
				</v-layout>

				<v-textarea v-model="channel.meta.description" label="Description"></v-textarea>

				<v-text-field v-model="channel.meta.play_url" label="Play url" v-if="channel.type == 'output' && $is_admin()"></v-text-field>
				<v-text-field v-model="channel.meta.monitor_url" label="Monitor url" v-if="channel.type == 'output' && $is_admin()"></v-text-field>
				<v-text-field v-model="channel.meta.page_url" label="Page url" v-if="channel.type == 'output' && $is_admin()"></v-text-field>

				<billing-customer-select v-if="channel.type == 'output' && $is_admin()" v-model="channel.meta" customer_name="billing_customer" customer_label="Billing customer" contract_name="billing_contract" contract_label="Billing contract"></billing-customer-select>

				<channel-group-select :id="id" type="access" v-model="channel_groups" label="Access group" v-if="$is_admin()"></channel-group-select>

				<override-editor v-model="channel.meta.overrides" :channel="channel" v-if="$is_admin()"></override-editor>

			<v-select v-if="channel.type == 'output' && $is_admin()" label="Event form" :items="event_forms" v-model="channel.meta.event_form" item-text="name" item-value="name">
			</v-select>

			<div v-if="(channel.type == 'output' || channel.type == 'input') && $is_admin()">

				<v-checkbox label="Use transcoder" v-model="channel.transcoder" color="orange darken-3" hide-details></v-checkbox>

				<div v-if="channel.transcoder == true">

					<template v-if="channel.type == 'output'">
						<v-checkbox label="Automatic transcoder"
						v-model="channel.meta.automatic_transcoder"
						color="orange darken-3"
						hide-details
						></v-checkbox>

						<v-checkbox label="Use MediaConnect"
						v-model="channel.meta.use_mediaconnect"
						color="orange darken-3"
						hide-details
						></v-checkbox>

						<div v-if="channel.meta.use_mediaconnect == true">
							<v-text-field v-model="channel.meta.mediaconnect_arns" label="MediaConnect arns (separated by ,)"></v-text-field>
						</div>
					</template>


					<v-layout row >
						<v-flex xs6>
							<v-autocomplete label="Transcoder size" :items="transcoderSizes" v-model="channel.meta.transcoder_size" item-text="name" item-value="value"></v-autocomplete>
						</v-flex>
						<v-flex xs6>
							<v-autocomplete label="Transcoder config" :items="transcoder_configurations" v-model="channel.meta.transcoder_config" :item-text="transcoder_configuration_item_text" item-value="name">
							</v-autocomplete>
						</v-flex>
					</v-layout>

					<v-text-field v-model="channel.meta.transcoder_tag" label="Transcoder tag"></v-text-field>
				</div>
			</div>

			<div v-if="$is_admin()"> 
				<v-checkbox label="Use pull" v-model="channel.meta.use_pull" color="orange darken-3" hide-details v-if="channel.type=='input'"></v-checkbox>
				<div v-if="channel.meta.use_pull">
					<v-text-field v-model="channel.meta.pull_url" label="Pull url"></v-text-field>
				</div>

				<template v-if="channel.type == 'output' && $is_admin()">
					<v-divider class="mt-3 mb-3" />
					<notifiers-editor v-model="channel.meta.notifiers" />
				</template>

				<v-checkbox label="System channel" v-model="channel.meta.system_channel" hide-details v-if="$is_admin()"></v-checkbox>
				<v-checkbox label="Is admin channel" v-model="channel.meta.is_admin_channel" hide-details v-if="$is_privilege('developer')"></v-checkbox>

			</div>

				</v-flex>
				<v-flex xs6 style="padding-bottom: 5px;" pr-1>
					<channel-group-select :id="id" type="template" v-model="channel_groups" label="Configuration presets" v-if="$is_admin()"></channel-group-select>
					<!--				<v-text-field v-model="channel.configuration" label="Configuration" multi-line style="height: 500px"></v-text-field>-->
					<v-tabs @change="override_preview_select">
						<v-tab>Preview</v-tab>
						<v-tab :class="override_classes">Overrides</v-tab>
						<v-tab-item>
							<json-editor v-model="preview_configuration" :readOnly="true" v-if="$is_admin()"></json-editor>
						</v-tab-item>
						<v-tab-item>
							<json-editor v-model="channel.configuration_overrides" v-if="$is_admin()"></json-editor>
						</v-tab-item>
					</v-tabs>
					<!--				<configuration v-model="configuration"></configuration>-->
				</v-flex>
			</v-layout>
		</v-card-text>
    <v-card-actions>

    	<template v-if="channel">
				<template v-if="channel.type == 'input' && channel.transcoder == true">
				<template v-if="instance">
					<v-btn color="error" @click="stop_streamer">Stop streamer</v-btn>
					<v-btn color="success" @click="open_gui">Control</v-btn>
				</template>
				<template v-if="!instance">
					<v-btn color="success" @click="start_streamer">Start streamer</v-btn>
				</template>
				</template>
			</template>



      <v-spacer></v-spacer>
			<v-btn flat @click="reset">Reset</v-btn>
			<v-btn color="error" v-show="is_edit && channel.state != 'archived'" @click="changeState('archived')">Archive</v-btn>
			<v-btn color="error" v-show="is_edit && channel.state == 'archived'" @click="changeState('active')">Unarchive</v-btn>
			<v-btn color="success" @click="save(false)">Save</v-btn>
			<v-btn color="success" @click="save(true)">Save and close</v-btn>
    </v-card-actions>
	</div>
</template>


<script>
import Configuration from './Configuration'
import JsonEditor from '@/components/JsonEditor'
import NotifiersEditor from '@/components/NotifiersEditor'
import SettingsModel from '@/models/settings.js'
import ChannelModel from '@/models/channel.js'
import InstanceModel from '@/models/instance.js'
import OverrideEditor from './OverrideEditor'
import BillingCustomerSelect from '@/components/form_items/BillingCustomerSelect'
import ChannelGroupSelect from './ChannelGroupSelect'
import naturalSort from 'natural-sort'

export default {
	components: {
		Configuration,
		JsonEditor,
		NotifiersEditor,
		OverrideEditor,
		BillingCustomerSelect,
		ChannelGroupSelect
	},
	props: ["id"],
	data () {
		var ch = this.$cloudserver.channel("channels:"+(this.id||"create"));
    return {
			ws_channel: ch,
    	channel: this.convertChannel(ch.data),
  //  	channelTypes: ChannelModel.types(),
      transcoderSizes: ChannelModel.transcoder_sizes(),
      channel_groups: [],
      preview_configuration: {},
      natural_sort: naturalSort()
    }
  },
	watch: {
		"ws_channel.data": {
			handler(newVal, oldVal) {
				if(typeof(newVal) != "undefined") {
					this.channel = this.convertChannel(newVal, oldVal);
				}
			},
			deep: true
		},
		'$route' (to, from) {
			if(typeof(from.meta.edit) != "undefined" && to.name == from.meta.edit) {
				this.ws_channel = this.$cloudserver.channel("channels:"+(this.id||"create"));
				this.ws_channel.join();
			}
		},
		channel_groups() {
			this.override_preview_select(0);
		}
	},
  created () {
  	this.ws_channel.join();
  },
  computed: {
  	instance () {
  		var ch = ChannelModel.get_channel(this.channel);
  		if (typeof(ch) != "undefined") {
	  		return ChannelModel.instance(this.channel);
	  	}
	  	return;
  	},
  	channelTypes () {
  		if (this.$is_admin() == true) return ChannelModel.types();
  		return [{label: "Input", value: "input"}];
  	},
		is_edit () {
			return typeof(this.channel) != "undefined" && this.channel.uuid != null;
		},
    transcoder_configurations () {
    	var list = SettingsModel.list("transcoder_configuration");
    	list.sort((a, b) => {
    		return this.natural_sort(a.title, b.title);
			});

      return list
    },
		event_forms () {
			return SettingsModel.list("event_form");
		},
		override_classes () {
			if(this.channel_groups.length > 0 && !_.isEmpty(this.channel.configuration_overrides)) return "deep-orange--text";
			if(!_.isEmpty(this.channel.configuration_overrides)) return "info--text";
			return []
		}
  },
  methods: {
    open_gui() {
      if (InstanceModel.gui_url(this.instance) != "") {
        window.open(InstanceModel.gui_url(this.instance));
      }
    },
  	override_preview_select(item) {
  		if(item == 0) {
  			if(this.$is_admin()) {
  				this.ws_channel.push("get_configuration", {configuration: this.channel.configuration_overrides, channel_groups: this.channel_groups})
  				.receive("ok", (msg) => {
  					this.preview_configuration = msg.data;
  				});
  			}
  		}
  	},
		changeState (state) {
      this.channel.state = state;
      this.save(false);
    },
    start_streamer () {
    	var self = this
    	if (this.channel.type == "input") {
        ChannelModel.start_transcoder(this.channel, (msg) => {
          self.$message.success("Streamer started!");
        }, (err) => {
          self.$message.success("Streamer start failed!" + JSON.stringify(msg));
        });
      }
    },
    stop_streamer () {
    	var self = this;
    	if (this.channel.type == "input") {
        var instance = ChannelModel.instance(this.channel);
    		InstanceModel.stop_transcoder(instance, (msg) => {
    			self.$message.success("Streamer stopped");
    		}, (err) => {
          self.$message.success("Streamer stop failed!" + JSON.stringify(err));
    		})
    	}
    },
    transcoder_configuration_item_text(config) {
    	if(_.isEmpty(config.title)) return config.name;
    	return config.title;
    },
		reset () {
			this.channel = this.convertChannel(this.ws_channel.data);
		},
  	save (close) {
			if(typeof(this.ws_channel) != "undefined") {
				var self = this;
				var channel = _.cloneDeep(this.channel);

				this.ws_channel.save({channel: channel, channel_groups: this.channel_groups})
					.then((msg) => {
						if (typeof(self.id) == "undefined") {
							self.$message.success("Channel was created!");
						} else {
							self.$message.success("Channel was updated!");
						}
						if(close) {
              self.$root.close_bottom_sheet();
            } else if(typeof(self.id) == "undefined" && typeof(this.$route.meta.edit) != "undefined") {
              this.$router.push({name: this.$route.meta.edit, params: {id: msg.data.channel.uuid}})
            }
					})
					.catch((msg) => {
						console.log(msg);
						if (typeof(self.id) == "undefined") {
							self.$message.warning("Unable to create channel!");
						} else {
							self.$message.warning("Unable to update channel!");
						}
					});
			}
  	},
		convertChannel (newVal, oldVal) {
			var channel = _.cloneDeep(newVal);
			if(typeof(oldVal) != "undefined") {
				//TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
			}

			if(typeof(channel) == "undefined" || _.isEmpty(channel)) return undefined;
			if(_.isEmpty(channel.meta.notifiers)) channel.meta.notifiers = [];

			return channel;
		}
  }
}
</script>
